import { IPowerbarStoreModule, registerAdapter, unregisterAdapter } from '../utils'
import { INavigationState } from './types'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import state from './state'

const NavigationState: IPowerbarStoreModule<INavigationState, any> = {
    name: 'NavigationState',
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}

NavigationState.register = registerAdapter(NavigationState);
NavigationState.unregister = unregisterAdapter(NavigationState);

export default NavigationState

